import React from "react";
import { PropTypes } from "prop-types";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import css from "../commonMagneticStyle.less";

const [HbrTooltip] = reactWrapper(["hbr-tooltip"]);

const QoEComponent = ({ iconType, qoeScore, qoeTextValue, reporting, ellipsis }) => {
  const textDiv = (
    <div className={ellipsis ? 
      (reporting ? `metric-bottom-value ${css["qoe-text-ellipsis"]}` : `metric-bottom ${css["qoe-text-ellipsis"]}`) : 
      (reporting ? "metric-bottom-value" : "metric-bottom")
    }>
      {qoeTextValue}
    </div>
  );
  
  return (
    <div className="metric" data-testid="legend-item">
      <div className={ellipsis ? `metric-top ${css["qoe-container-flex"]}` : "metric-top"}>
        <div className={`metric-top-icon-${iconType}`}>&nbsp;</div> 
        <div className={reporting ? "metric-top-calculation-changeorder" : "metric-top-calculation"}>
          {qoeScore}
        </div>
        {ellipsis ? <HbrTooltip content={qoeTextValue} placement="top">{textDiv}</HbrTooltip> : textDiv}
      </div>
    </div>
  );
};

QoEComponent.propTypes = {
  iconType: PropTypes.string,
  qoeScore: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  qoeTextKey: PropTypes.string,
  reporting: PropTypes.bool,
  qoeTextValue: PropTypes.string,
  qoePercentage: PropTypes.string,
  pathAction: PropTypes.string,
  ellipsis: PropTypes.bool
};

export default QoEComponent;
